export const RESTStatus = Object.freeze({
    Ok: 'Ok',
    Error: 'Error'
})